import { render, staticRenderFns } from "./MarketingMail.vue?vue&type=template&id=250ecf2e&"
import script from "./MarketingMail.vue?vue&type=script&lang=js&"
export * from "./MarketingMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports